import { render, staticRenderFns } from "./CustomerNonActiveDetails.vue?vue&type=template&id=8ea7727c&"
import script from "./CustomerNonActiveDetails.vue?vue&type=script&lang=js&"
export * from "./CustomerNonActiveDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports